export const ALT_TEXT_ENTRY_POINTS = {
  DIRECT_PROPS: 'directProps',
  MCC: 'mcc',
} as const;
